import React from "react";
import styles from "./Stop.module.scss";
import stop from "../icons/stop.png";

const StopButton = (props)=>{
    return (
        <div className="hex">
        <div className={styles.stop_tractor}>
            <img alt="stop" src={stop}></img>
            <span className={styles.stop_tooltip}>Stop Tractor</span>
        </div>
    </div>
    )
}

export default StopButton